import { render, staticRenderFns } from "./GlobalQuickView.vue?vue&type=template&id=63e930ec&scoped=true"
import script from "./GlobalQuickView.vue?vue&type=script&lang=js"
export * from "./GlobalQuickView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e930ec",
  null
  
)

export default component.exports